// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styleHelpers-fontSizeButton_cls1__3qrb3","cls2":"styleHelpers-fontSizeButton_cls2__35Sd1 styleHelpers-fontSizeButton_cls1__3qrb3"};